import Review from './partial/review'
import ExamRecord from './partial/exam-record'
import License from './partial/license'
const groupName = (d) => {
  console.log(d.courierGroups)
  if(d.courierGroups){
    return d.courierGroups.map(i => i.groupName).join(';')
  }else{
    return ''
  }
}
export default {
  data() {
    return {
      data: {},
      modalVisible: false,
      reviewable:false,
    }
  },

  created() {

  },

  methods: {
    init(id , reviewable = false) {
      this.reset()

      this.id = id
      this.reviewable = reviewable
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.data = {}
      this.id = null
    },
    query() {
      this.loading = true
      this.$request.licenseExamRecord(this.id).then(resp => {
        resp.data = this.$utils.conv(resp.data, {'gender':'gender'})
        this.data = resp.data || {}
        this.loading = false
      })
    },
    review(){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review courier-id={this.id} />
        },
        onOk: () => {
          this.query()
        }
      })
    }
  },
  render() {
    const data = this.data || {}
    const slots = data.state == 0 && this.reviewable? {
      footer:() => {
        return <Button type="primary" on-click={this.review}>审核</Button>
      } 
    }:null

    const photos = data.headImg ? data.headImg.split(';') : []
    return <sl-side-panel scopedSlots={slots} v-model={this.modalVisible} loading={this.loading} mask-closable={false} title="基本信息" on-close={this.reset}>
      <Tabs value="t1">
        {
          this.$a('courier.list.detail.base') ? <TabPane label="基本信息" name="t1">
          <sl-detail-list col={1} labelAlign="right" labelWidth="100px" style="padding:12px;">
            <sl-detail-list-item title="姓名">{data.name}</sl-detail-list-item>
            <sl-detail-list-item title="证件号码">{data.idcard}</sl-detail-list-item>
            <sl-detail-list-item title="性别">{data.genderText}</sl-detail-list-item>
            <sl-detail-list-item title="电话">{data.phone}</sl-detail-list-item>
            <sl-detail-list-item title="头像"><sl-img width="150px" public={true} src={data.headshot} method="1" /></sl-detail-list-item>

            <sl-detail-list-item title="一寸照">
              <sl-img width="150px" public={true} src={photos[0]} method="1" />
            </sl-detail-list-item>
            <sl-detail-list-item title="身份证正面">
              <sl-img width="150px" public={true} src={photos[1]} method="1" />
            </sl-detail-list-item>
            <sl-detail-list-item title="身份证反面">
              <sl-img width="150px" public={true} src={photos[2]} method="1" />
            </sl-detail-list-item>
            <sl-detail-list-item title="所属企业">{data.companyName}</sl-detail-list-item>
            <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
          </sl-detail-list>
        </TabPane> : null
        }
        <TabPane label="考试信息" value="t2">
          <ExamRecord id={data.memberId} />
        </TabPane>

        <TabPane label="证照详情" value="t3"><License exam-record-id={data.id} /></TabPane>
      </Tabs>
    </sl-side-panel>
  }
}
